import ServiceBase from './ServiceBase';

export default class ProjectTagsService extends ServiceBase {

    createProjectTag(projectTag) {
        const params = {
            ...projectTag,
        };

        return this.request('post', 'admin/projectTags/createProjectTag', params);
    }

    deleteProjectTag(projectTagID) {
        const params = {
            projectTagID,
        };

        return this.request('post', 'admin/projectTags/deleteProjectTag', params);
    }

    searchProjectTags(filters = {}, pageSize = null, pageIndex = null) {
        const params = {
            pageSize,
            pageIndex,
            ...filters,
        };

        return this.request('post', 'admin/projectTags/searchProjectTags', params);
    }

    updateProjectTag(projectTag) {
        const params = {
            ...projectTag,
        };

        return this.request('post', 'admin/projectTags/updateProjectTag', params);
    }

    isProjectTagNameTaken(projectTagID, name) {
        return this.request('get', 'admin/projectTags/isProjectTagNameTaken', { params: { projectTagID, name } });
    }

    changeProjectTagSortOrder(projectTag) {
        const params = {
            ...projectTag,
        };

        return this.request('post', 'admin/projectTags/changeProjectTagSortOrder', params);
    }

    getTags() {
        return this.request('get', 'projectTags/getTags');
    }
}
